import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetLatestReconciledAMRRecord() {
  const response = await $.soap({
    body: {
      GetLatestReconciledAMRRecord: {
        $xmlns: 'http://dla.mil/ems/bpm/amr'
      }
    },
    blueprint: {
      amr:
        {
          id: '$..ID',
          csFileId: '$..CSFileID',
          reconciledCSFileId: '$..ReconciledCSFileID',
          uploadedBy: '$..UploadedBy',
          uploadedOn: '$..UploadedOn',
          isProcessed: '$..IsProcessed',
          processedOn: '$..ProcessedOn'
        }
    }
  });

  cleanUpResponse(response);
  return response.amr;
}
